// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import ClusterOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ClusterOutlined';
import TeamOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TeamOutlined';
export default { SmileOutlined, CrownOutlined, ClusterOutlined, TeamOutlined };
